export default () => ({
    open: false,
    _boundPageHide: null,
    _morphedCleanup: null,
    _navigateRef: null,

    init() {
        // bfcache / regular unload: make sure a previously open dropdown does
        // not survive as a zombie open state into a restored page.
        this._boundPageHide = () => {
            this._forceClose();
        };
        window.addEventListener('pagehide', this._boundPageHide);

        // Livewire navigate (back/forward + bfcache): close any still-open
        // dropdown before the new page initialises Alpine, otherwise an
        // `open` state can survive into a stale DOM.
        this._navigateRef = () => {
            this._forceClose();
        };
        window.addEventListener('livewire:navigate', this._navigateRef);
        window.addEventListener('livewire:navigating', this._navigateRef);

        // Livewire morph hook: if our root is gone or got morphed while the
        // dropdown is open, close it so we don't keep an open state attached
        // to a detached DOM. Child morphs inside our root are intentionally
        // ignored – they are normal Livewire updates.
        if (typeof window !== 'undefined' && window.Livewire?.hook) {
            this._morphedCleanup = window.Livewire.hook('morphed', (component) => {
                if (!this.open) return;

                const root = this.$root;
                if (!root || !root.isConnected) {
                    this._forceClose();
                    return;
                }
                const el = component?.el;
                if (el && (el === root || el.contains(root))) {
                    this._forceClose();
                }
            });
        }
    },
    toggle() {
        if (this.open) { return this.close() }

        // Guard against stale / detached refs (e.g. after a Livewire morph):
        // never throw out of a user click, simply stay closed.
        const button = this.$refs.button;
        if (!button || !button.isConnected) return;

        button.focus();
        this.open = true
    },
    close(focusAfter) {
        if (! this.open) return
        this.open = false
        focusAfter && focusAfter.focus()
    },
    // Close unconditionally. Used by morph / pagehide paths where we cannot
    // rely on this.open being accurate anymore.
    _forceClose() {
        this.open = false;
    },
    destroy() {
        if (this._boundPageHide) {
            window.removeEventListener('pagehide', this._boundPageHide);
            this._boundPageHide = null;
        }
        if (typeof this._morphedCleanup === 'function') {
            this._morphedCleanup();
            this._morphedCleanup = null;
        }
        if (this._navigateRef) {
            window.removeEventListener('livewire:navigate', this._navigateRef);
            window.removeEventListener('livewire:navigating', this._navigateRef);
            this._navigateRef = null;
        }
    },
})
